import { render, staticRenderFns } from "./ViewMenu.vue?vue&type=template&id=2286be66&scoped=true"
import script from "./ViewMenu.vue?vue&type=script&lang=js"
export * from "./ViewMenu.vue?vue&type=script&lang=js"
import style0 from "./ViewMenu.vue?vue&type=style&index=0&id=2286be66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286be66",
  null
  
)

export default component.exports